import { validationRulesCreator as rules } from 'brastrap/common/address-field-set/AddressFieldSet';
import validator from '../../../utils/validation';

const detailRules = {
  title: [],
  firstName: ['required'],
  lastName: ['required'],
};

/**
 * Validates the supplied form values.
 * @param {Object} fields the data to validate
 * @param {Object} formatMessage react-intl
 * @return {Object} a key-value of any errors found
 */
function validateForm(fields, { intl: { formatMessage } }) {
  const addressRules = rules(fields.address.countryId, false);
  let errors = {
    details: validator(fields.details, detailRules, formatMessage),
    address: validator(fields.address, addressRules, formatMessage),
  };

  if (fields.email) {
    errors = {
      ...errors,
      ...validator(fields, { email: ['email'] }, formatMessage),
    };
  }

  return errors;
}

export default validateForm;
